import { enableProdMode } from '@angular/core'
import { bootstrapApplication } from '@angular/platform-browser'

import dayjs from 'dayjs/esm'
import isSameOrBefore from 'dayjs/esm/plugin/isSameOrBefore'
import timezone from 'dayjs/esm/plugin/timezone'
import utc from 'dayjs/esm/plugin/utc'

import { ENV } from '~env/environment'

import { AppComponent } from './app/app.component'
import { config } from './app/app.config.client'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isSameOrBefore)

if (ENV.production) {
  enableProdMode()
}

bootstrapApplication(AppComponent, config).catch(err => console.error(err))
